<script lang="ts">
    import Title from "../Components/Title.svelte";
    import Container from "../Components/Container.svelte";
    import Button from "../Components/Button.svelte";
    import {navigateTo} from "svelte-router-spa";
    import { handApi } from "../Core/HandApi";
    import {alertShown, modalComponent} from "../Core/Store";
    import UserPassIncorrect from "../Modals/UserPassIncorrect.svelte";
    import GenericLoading from "../Modals/GenericLoading.svelte";
    import {accessToken, lastUsername, refreshToken, userData} from "../Core/LocalStorage";
    import PasswordReset from "../Modals/PasswordReset.svelte";
    import GenericError from "../Modals/GenericError.svelte";
    import {onMount} from "svelte";

    let username:string, password:string, signingIn:boolean = false,
        usernameError:boolean = false, passwordError:boolean = false;

    if ($lastUsername !== 'null') {
        username = $lastUsername;
    }

    function validateForm(passwordVal = false) : boolean {
        usernameError = false;
        passwordError = false;
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(username)) {
            usernameError = true;
        }

        if (!passwordVal) {
            return !usernameError;
        }

        if (!password || password.length < 6) {
            passwordError = true;
        }

        return !(usernameError || passwordError);
    }

    async function signIn() {
        if (!validateForm(true)) {
            return;
        }

        signingIn = true;

        let result = await handApi.login(username, password);
        if (!result.success) {
            modalComponent.set(UserPassIncorrect);
            alertShown.set(true);
            signingIn = false;
            return;
        }

        lastUsername.set(username);
        accessToken.set(result.accessToken);
        refreshToken.set(result.refreshToken);

        await attemptUserDataNavigate(true);
    }

    async function forgotPassword() {
            if (!signingIn) {
                if (!validateForm()) {
                    return;
                }

                modalComponent.set(GenericLoading);
                alertShown.set(true);

                let result = await handApi.forgot(username);

            modalComponent.set(PasswordReset);
        }
    }

    async function attemptUserDataNavigate(withError = false) {
        try {
            let data = await handApi.userData();
            console.log('data');
            console.log(data);
            if (data === null) {
                if (withError) {
                    modalComponent.set(GenericError);
                    alertShown.set(true);
                    signingIn = false;
                } else {
                    alertShown.set(false);
                    signingIn = false;
                }
                return;
            }
            alertShown.set(false);
            userData.set(data);
            navigateTo('/home');
        } catch {
            modalComponent.set(GenericError);
            alertShown.set(true);
            signingIn = false;
        }
    }

    onMount(async () => {
        if ($accessToken !== null && $accessToken !== 'null') {
            modalComponent.set(GenericLoading);
            alertShown.set(true);
            await attemptUserDataNavigate(false);
        }
    })
</script>

<div class="flex flex-col h-full relative bg-gradient-to-b from-hand-orange-500 to-hand-pink-500">
    <main class="flex-1 flex flex-col items-center justify-center">
        <img src="/image/hand-logo.png" alt="HAND Logo" class="max-h-48 mt-6 mb-12 filter brightness-0 invert" />

        <form class="max-w-sm w-full grid gap-4 px-4">
            <div>
                <label for="email" class="block text-sm font-medium text-gray-50">Email Address</label>
                <div class="mt-1 border-b border-gray-300 focus-within:border-hand-purple-500">
                    <input type="email" bind:value={username} on:input={() => usernameError = false} autocomplete="username" required id="email" class="block w-full text-white placeholder-gray-200 border-0 bg-transparent border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm" placeholder="handuser@gmail.com">
                </div>
                {#if usernameError}
                    <div class="mt-1 bg-white rounded-lg flex px-2 py-1 items-center justify-center text-sm font-bold text-red-700">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Your Email doesn't seem correct.
                    </div>
                {/if}
            </div>
            <div>
                <label for="password" class="block text-sm font-medium text-gray-50">Password</label>
                <div class="mt-1 border-b border-gray-300 focus-within:border-hand-purple-500">
                    <input type="password" on:input={() => passwordError = false} bind:value={password}  autocomplete="current-password" name="name" id="password" class="block w-full text-white placeholder-gray-200 border-0 bg-transparent border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm" placeholder="I4mV3rySecure?">
                </div>
                {#if passwordError}
                    <div class="mt-1 bg-white rounded-lg flex px-2 py-1 items-center justify-center text-sm font-bold text-red-700">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        That's not a valid password.
                    </div>
                {/if}
            </div>
            <div class="text-center">
                <Button type="submit" styles="block mx-auto mb-4 w-48" bind:loading={signingIn} on:click={signIn}>
                    Sign In to HAND
                </Button>
                <a href="#" on:click|preventDefault={forgotPassword} class="text-white">Forgot your Password?</a>
            </div>
        </form>
    </main>
</div>